import {CONSONANT_VOWEL_PAIRS_KK} from "../../../SubjectData/Phonetics/ConsonantVowelPairs/ConsonantVowelPairs_kk";
import "../../Deck.css";
import FlashcardInterface from "../../Flashcard_Interface.js";
import HeaderNav from "../../../Components/Header/Header_Nav/Header_Nav.js";



export default function CONSONANT_VOWEL_PAIRS_KK_DECK() {


 return(
 
     <>
        <HeaderNav GoBack_to={"/ConsonantVowelPairsNav"}/>
        <FlashcardInterface deckData={CONSONANT_VOWEL_PAIRS_KK} title="Consonant-Vowel Pairs: ㄲ (kk)" />
     </>
);}